<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-2">
          <v-toolbar
            flat
            color="white"
          >
            <v-toolbar-title> Position Job Requirements </v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="positions"
            :loading="loading"
            :single-expand="true"
          >
            <template v-slot:item="props">
              <tr
                style="cursor: pointer;"
                @click="props.expand(!props.isExpanded); loadGrades(props.item.id, props.item.category.id);"
              >
                <td>
                  <v-btn icon>
                    <v-icon>{{ props.isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                  </v-btn>
                  {{ props.item.name }}
                </td>            
                <td>{{ props.item.category.name }}</td>
              </tr>
            </template>        
            <template v-slot:expanded-item="{ item, headers }">
              <td
                :colspan="headers.length"
                class="px-0"
              >
                <v-card class="elevation-5">              
                  <v-toolbar 
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Grades</v-toolbar-title>
                  </v-toolbar>
                  <v-data-table
                    :headers="gradeHeaders"
                    :items="grades[item.id]"
                    :loading="loadingGrades[item.id]"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.icon="{ item: gradeItem }">
                      <v-avatar
                        tile
                        size="36"
                      >
                        <v-img :src="gradeItem.image_url" />
                      </v-avatar>  
                    </template>   
                    <template v-slot:item.action="{ item: gradeItem }">     
                      <setup-positions-job-requirements-sidebar
                        :position="item"
                        :grade="gradeItem"
                      />
                    </template>              
                  </v-data-table>
                </v-card>
              </td>
            </template>      
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupPositionsJobRequirementsSidebar: () => import('@/components/setup/positions/job-requirements/Sidebar'),
    },
    metaInfo () {
      return {
        title: 'Setup - Position Job Requirement',
      }
    },
    data () {
      return {
        loading: false,
        loadingGrades: [],
        positions: [],
        grades: [],
        headers: [
          {
            text: 'Position',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Category',
            align: 'left',
            value: 'category.name',
          },
        ],
        gradeHeaders: [
          {
            text: 'Rank',
            align: 'left',
            value: 'value',
          },
          {
            text: 'Badge',
            align: 'left',
            sortable: false,
            value: 'icon',
          },
          {
            text: 'Title',
            align: 'left',
            sortable: false,
            value: 'title',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'pivot.name',
          },
          {
            text: 'Description',
            align: 'left',
            sortable: false,
            value: 'pivot.description',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.positions().list(true)
          .then(response => {
            this.positions = response.data

            this.loading = false
          })
      },
      loadGrades (positionId, categoryId, forceRefresh = false) {
        if ((this.grades[positionId] || []).length > 0 && !forceRefresh) return

        this.$set(this.loadingGrades, positionId, true)

        this.$api.grades().list(categoryId)
          .then(response => {
            this.$set(this.grades, positionId, response.data)

            this.$set(this.loadingGrades, positionId, false)
          })
      },
    },
  }
</script>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-table__overflow{
    overflow-x: hidden;
  }
</style>
